'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CarouselFigure = require('./CarouselFigure');

var _CarouselFigure2 = _interopRequireDefault(_CarouselFigure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _CarouselFigure2["default"];
module.exports = exports['default'];